import { environmentConfig } from '@/config/enviromentConfig'

const SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'
const CONTAINER_ID = 'cf-turnstile-container'
const EXECUTE_TIMEOUT_MS = 5000
const WIDGET_READY_TIMEOUT_MS = 5000

export const WIDGET_ID = 'mzansiRhythm'

let initialized = false
let widgetId = null
let pending = null
let ready = false
let readyWaiters = []

function settleReadiness() {
    if (ready) return

    ready = true

    const waiters = readyWaiters
    readyWaiters = []

    waiters.forEach((waiter) => waiter())
}

function waitForReady(timeoutMs) {
    if (ready) return Promise.resolve()

    return new Promise((resolve) => {
        const timer = setTimeout(resolve, timeoutMs)
        readyWaiters.push(() => {
            clearTimeout(timer)
            resolve()
        })
    })
}

function resolvePending(token) {
    const resolve = pending

    pending = null

    if (resolve) resolve(token)
}

function rearmWidget() {
    try {
        if (widgetId) window.turnstile?.reset(widgetId)
    } catch {
    }
}

function renderWidget() {
    try {
        const params = {
            sitekey: environmentConfig.turnstileSiteKey,
            execution: 'execute',
            appearance: 'execute',
            callback: (token) => resolvePending(token),
            'error-callback': () => resolvePending(null),
            'timeout-callback': () => resolvePending(null),
        }

        widgetId = window.turnstile?.render('#' + CONTAINER_ID, params) ?? null
        rearmWidget()
    } catch {
        widgetId = null
    }
    settleReadiness()
}

export function initTurnstile() {
    if (initialized || !environmentConfig.turnstileSiteKey) return

    initialized = true

    try {
        const container = document.createElement('div')
        container.id = CONTAINER_ID
        container.style.cssText =
            'position:fixed;left:-9999px;top:0;width:300px;height:65px;opacity:0;pointer-events:none;'
        document.body.appendChild(container)

        const script = document.createElement('script')
        script.src = SCRIPT_URL
        script.async = true
        script.defer = true
        script.onload = renderWidget
        script.onerror = settleReadiness
        document.head.appendChild(script)
    } catch {
    }
}

async function executeForToken(action) {
    if (!environmentConfig.turnstileSiteKey) {
        return null
    }
    if (!ready) {
        await waitForReady(WIDGET_READY_TIMEOUT_MS)
    }
    if (!widgetId || !window.turnstile) {
        return null
    }

    return new Promise((resolve) => {
        let timer = null
        let retried = false

        const fire = () => {
            try {
                window.turnstile.execute('#' + CONTAINER_ID, { action })
            } catch {
                settle(null)
            }
        }

        const onTimeout = () => {
            if (timer === null) return

            if (!retried) {
                retried = true
                timer = setTimeout(onTimeout, EXECUTE_TIMEOUT_MS)
                fire()
                return
            }

            settle(null)
        }

        const settle = (token) => {
            if (timer === null) return

            clearTimeout(timer)
            timer = null

            if (pending === settle) pending = null

            resolve(token)
            rearmWidget()
        }

        pending = settle
        timer = setTimeout(onTimeout, EXECUTE_TIMEOUT_MS)

        fire()
    }).catch(() => null)
}

let executionTail = null

export function getCaptchaToken(action) {
    const result = executionTail
        ? executionTail.then(() => executeForToken(action))
        : executeForToken(action)

    const tail = result
        .then(
            () => undefined,
            () => undefined
        )
        .then(() => {
            if (executionTail === tail) executionTail = null
        })

    executionTail = tail

    return result
}
